import * as types from "../mutation-types"
import * as discountAPI from "../api/discounts"
// initial state
const discounts = {
    namespace: 'discounts',
    state: {
        all: [],
    },
    getters: {
        discounts: (state) => state.all.sort((a, b) => b.id - a.id),
    },
    mutations: {
        [types.CREATE_DISCOUNT]: (state, discount) => {
            state.all.push(discount)
        },
        [types.UPDATE_DISCOUNT]: (state, {discount, newDiscount}) => {
            let index = state.all.indexOf(state.all.find(dis => dis.id === discount.id))
            state.all.splice(index, 1, newDiscount)
        },
        [types.DELETE_DISCOUNT]: (state, discount) => {
            let index = state.all.indexOf(state.all.find(dis => dis.id === discount.id))
            state.all.splice(index, 1)
        },
    },

    actions: {
        [types.CREATE_DISCOUNT]: ({commit, dispatch, state}, discount) => {
            return new Promise((resolve, reject) => {
                discountAPI.createDiscount(commit, discount)
                    .then(data => {
                        commit(types.CREATE_DISCOUNT, data)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        [types.UPDATE_DISCOUNT]: ({commit, dispatch, state}, {discount, newDiscount}) => {
            return new Promise((resolve, reject) => {
                discountAPI.updateDiscount(commit, {discount, newDiscount})
                    .then(data => {
                        commit(types.UPDATE_DISCOUNT, {discount, newDiscount})
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        },
        [types.DELETE_DISCOUNT]: ({commit, dispatch, state}, discount) => {
            return new Promise((resolve, reject) => {
                discountAPI.deleteDiscount(commit, discount)
                    .then(data => {
                        commit(types.DELETE_DISCOUNT, discount)
                        resolve(data)
                    })
                    .catch(error => {
                        reject(error)
                    });
            })
        }
    },
};

export default discounts;



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/discounts/index.js
// module id = 614
// module chunks = 0